var append = Node.prototype.appendChild;
var insertBefore = Node.prototype.insertBefore;
var wrapped = [];

function wrap(element) {
    'use strict';
    if (element.tagName && element.tagName.toLowerCase() === 'script' && element.src && !element.src.match(/chunks/)) {
        return wrapped.push(element);
    }
}

Node.prototype.appendChild = function (element) {
    'use strict';
    return wrap(element) || append.apply(this, arguments);
};

Node.prototype.insertBefore = function (element) {
    'use strict';
    return wrap(element) || insertBefore.apply(this, arguments);
};

module.exports = function() {
	'use strict';
	Node.prototype.appendChild = append;
	Node.prototype.insertBefore = insertBefore;
	wrapped.forEach(function(el) {document.head.appendChild(el);});
};



//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/3rdparty/script/createElement.hook.js
// module id = 844
// module chunks = 4